import { useState, useEffect, useRef } from "react";
import ArticleCard from "../../Universal/ArticleCard";
import LoadingSpinner from "../../Universal/LoadingSpinner";
import { CardPreview } from "./Badges";
import { useCompanyContext } from "../../../context/CompanyContext";

const SOCIAL_SOURCE_LABELS = {
  tiktok: "TikTok",
  instagram: "Instagram",
  x: "X",
  twitter: "X",
  facebook: "Facebook",
  youtube: "YouTube",
};

const getDisplayArticle = (article, currentCompany) => {
  const sourceKey =
    typeof article?.source === "string" ? article.source.toLowerCase() : "";

  const sourceLabel = SOCIAL_SOURCE_LABELS[sourceKey];

  const displayTitle =
    sourceKey === "tiktok"
      ? [currentCompany?.case, sourceLabel].filter(Boolean).join(" - ")
      : article?.title;

  return {
    ...article,
    title: displayTitle,
  };
};

/* ─── Feed card wrapper (manages hover state for preview) ─── */
export const FeedCard = ({
  id,
  article,
  t,
  onCardClick,
  isActive,
  typeBadge,
  onCardInteract,
}) => {
  const { currentCompany } = useCompanyContext();
  const [broken, setBroken] = useState(false);

  if (broken) return null;

  const articleForDisplay = getDisplayArticle(article, currentCompany);

  return (
    <div
      className="relative cursor-pointer"
      onClick={() => onCardClick(id, articleForDisplay)}
    >
      <ArticleCard
        investigateDoc={(doc) => onCardClick(id, doc)}
        article={articleForDisplay}
        articleURL={articleForDisplay.url}
        articleLike={articleForDisplay.like}
        articleDislike={articleForDisplay.dislike}
        articleCatalog={articleForDisplay.catalog}
        lid={`${id}||like`}
        dlid={`${id}||dislike`}
        cid={`${id}||catalog`}
        isActive={isActive}
        typeBadge={typeBadge}
        hoverPreview={<CardPreview article={articleForDisplay} t={t} />}
        onInteract={(state) =>
          onCardInteract?.(id, articleForDisplay.document_id, state)
        }
        onBroken={() => setBroken(true)}
      />
    </div>
  );
};

/* ─── Infinite Scroll Sentinel ─── */
export const ScrollSentinel = ({ onIntersect, hasMore, isLoadingMore, t }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !hasMore) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !isLoadingMore) onIntersect();
      },
      { rootMargin: "400px" },
    );

    obs.observe(ref.current);

    return () => obs.disconnect();
  }, [hasMore, isLoadingMore, onIntersect]);

  return (
    <div ref={ref} className="w-full flex justify-center py-8">
      {isLoadingMore && hasMore && <LoadingSpinner />}

      {!hasMore && (
        <p
          className="text-sm font-normal"
          style={{
            color: t?.textMuted ?? "rgba(148,163,184,0.4)",
          }}
        >
          You've reached the end
        </p>
      )}
    </div>
  );
};
